import { AuthTabList } from "models/Auth";

export const setAuth = (authList: AuthTabList) => ({
  type: "auth/seachTab/SET_AUTH" as const,
  payload: authList
});

export type AuthSearchTabAction = ReturnType<typeof setAuth>;
